import { isBrowser, isFrame } from '@utils';
import React, { useMemo } from 'react';
import CookieConsent from 'react-cookie-consent';
import { embeddablePaths } from '@config/paths';
import { useI18n } from '../context/I18nContext';
import { getPathWithoutLocale } from '@utils/websiteUrlUtils';

// Simple inline type declaration following existing patterns
declare global {
  interface Window {
    gtag?: (...args: any[]) => void;
  }
}

const Cookies: React.FC = () => {
  const { t } = useI18n();
  const show = useMemo(() => {
    if (isBrowser()) {
      const basePath = getPathWithoutLocale(window.location.pathname);
      const isEmbeddable = embeddablePaths.includes(basePath);
      if (isEmbeddable) {
        return !isFrame();
      }
      return true;
    }
    return false;
  }, []);

  const handleAccept = () => {
    // Update consent when user accepts - following existing inline analytics pattern
    if (isBrowser() && window.gtag) {
      window.gtag('consent', 'update', {
        ad_storage: 'granted',
        ad_user_data: 'granted',
        ad_personalization: 'granted',
        analytics_storage: 'granted'
      });
    }
  };

  if (!show) {
    return <></>;
  }

  return (
    <CookieConsent
      location='bottom'
      buttonText={t('common:cookies.accept')}
      cookieName='cookieConsent'
      contentClasses='cookieContentClass'
      buttonWrapperClasses='cookieButtonClass'
      onAccept={handleAccept}
      style={{
        background: '#243636',
        alignItems: 'center',
      }}
      buttonStyle={{
        backgroundColor: '#007060',
        borderRadius: '12px',
        height: '52px',
        padding: '0px 24px',
        color: '#fff',
        fontSize: '16px',
        fontWeight: '700',
        textTransform: 'uppercase',
        lineHeight: '20.8px',
      }}
      expires={150}
    >
      <span
        style={{
          fontSize: '16px',
          fontWeight: 400,
          lineHeight: '20.8px',
          letterSpacing: '-1%',
        }}
      >
        <div>{t('common:cookies.message')}</div>
      </span>
    </CookieConsent>
  );
};

export default Cookies;
